/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SingleTeamStatistic = {
    properties: {
        value: {
            type: 'number',
            isRequired: true,
        },
        extraValue: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        team: {
            type: 'TeamListWithoutLeagues',
            isRequired: true,
        },
        placement: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
